var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 .979C9.51.979.976 9.53.976 20.041.976 30.553 9.51 39.105 20 39.105s19.024-8.552 19.024-19.063C39.024 9.53 30.49.979 20 .979zm0 39.103c-11.028 0-20-8.99-20-20.04C0 8.991 8.972.001 20 .001c11.03 0 20 8.99 20 20.04 0 11.051-8.971 20.041-20 20.041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.955 22.954v-5.909L23.182 20l-5.227 2.954zm11.627-7.768a2.507 2.507 0 00-1.768-1.769c-1.56-.416-7.814-.416-7.814-.416s-6.254 0-7.814.417c-.86.23-1.538.908-1.768 1.769C10 16.746 10 20 10 20s0 3.254.418 4.813c.23.861.908 1.539 1.768 1.769C13.746 27 20 27 20 27s6.254 0 7.814-.418a2.506 2.506 0 001.768-1.769c.418-1.56.418-4.812.418-4.812s0-3.255-.418-4.814z"
  }))));
};
export default SvgYoutube;